import React from "react";
import { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import FiltroMultiple from "../../Postventa/Dashboard/Modales/FiltroMultiple";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const InvoiceTable = ({ data, onOrigenChange }) => {
  const [options, setOptions] = useState({
    origen: [],
    fecha: [],
    serie_fiscal: [],
    folio_fiscal: [],
    cuenta: [],
    comprobante: [],
    condicion: [],
    cancelado: [],
    fecha_cancelacion: [],
  });
  const [filtros, setFiltros] = useState({
    origen: [],
    fecha: [],
    serie_fiscal: [],
    folio_fiscal: [],
    cuenta: [],
    comprobante: [],
    condicion: [],
    cancelado: [],
    fecha_cancelacion: [],
  });
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [filtrosTemp, setFiltrosTemp] = useState({
    origen: [],
    fecha: [],
    serie_fiscal: [],
    cuenta: [],
    comprobante: [],
    condicion: [],
    cancelado: [],
    fecha_cancelacion: [],
  });

  const [mostrarFiltro, setMostrarFiltro] = useState({
    origen: { open: false },
    fecha: { open: false },
    serie_fiscal: { open: false },
    cuenta: { open: false },
    comprobante: { open: false },
    condicion: { open: false },
    cancelado: { open: false },
    fecha_cancelacion: { open: false },
  });

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);

      let nuevasPrioridades;

      // nuevo filtro → se agrega
      if (index === -1) {
        nuevasPrioridades = [...prev, filtro];
      }
      // filtro existente → se cortan los posteriores
      else {
        nuevasPrioridades = prev.slice(0, index + 1);
      }

      // 🔥 LIMPIAR filtros que perdieron prioridad
      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      // 🔥 LIMPIAR filtros aplicados también
      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
    let resultado = [...data];

    filtrosPermitidos.forEach((filtro) => {
      if (filtro === "origen" && filtros.origen.length > 0) {
        resultado = resultado.filter((i) => filtros.origen.includes(i.origen));
      }
      if (filtro === "fecha" && filtros.fecha.length > 0) {
        resultado = resultado.filter((i) => filtros.fecha.includes(i.fecha));
      }
      if (filtro === "serie_fiscal" && filtros.serie_fiscal.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.serie_fiscal.includes(i.serie_fiscal),
        );
      }

      if (filtro === "cuenta" && filtros.cuenta.length > 0) {
        resultado = resultado.filter((i) => filtros.cuenta.includes(i.cuenta));
      }

      if (filtro === "comprobante" && filtros.comprobante.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.comprobante.includes(i.tipoComprobante),
        );
      }

      if (filtro === "condicion" && filtros.condicion.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.condicion.includes(i.condicionPago),
        );
      }

      if (filtro === "cancelado" && filtros.cancelado.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.cancelado.includes(String(i.cancelado)),
        );
      }

      if (
        filtro === "fecha_cancelacion" &&
        filtros.fecha_cancelacion.length > 0
      ) {
        resultado = resultado.filter((i) =>
          filtros.fecha_cancelacion.includes(i.fechacancelacion),
        );
      }
    });

    return resultado;
  };

  useEffect(() => {
    if (!Array.isArray(data)) return;

    let result = [...data];

    prioridadFiltros.forEach((filtro) => {
      switch (filtro) {
        case "origen":
          if (filtros.origen.length > 0) {
            result = result?.filter((i) => filtros.origen.includes(i.origen));
          }
          break;

        case "fecha":
          if (filtros.fecha.length > 0) {
            result = result?.filter((i) => filtros.fecha.includes(i.fecha));
          }
          break;

        case "serie_fiscal":
          if (filtros.serie_fiscal.length > 0) {
            result = result?.filter((i) =>
              filtros.serie_fiscal.includes(i.serie_fiscal),
            );
          }
          break;

        case "cuenta":
          if (filtros.cuenta.length > 0) {
            result = result?.filter((i) => filtros.cuenta.includes(i.cuenta));
          }
          break;

        case "comprobante":
          if (filtros.comprobante.length > 0) {
            result = result?.filter((i) =>
              filtros.comprobante.includes(i.tipoComprobante),
            );
          }
          break;

        case "condicion":
          if (filtros.condicion.length > 0) {
            result = result?.filter((i) =>
              filtros.condicion.includes(i.condicionPago),
            );
          }
          break;

        case "cancelado":
          if (filtros.cancelado.length > 0) {
            result = result?.filter((i) =>
              filtros.cancelado.includes(String(i.cancelado)),
            );
          }
          break;

        case "fecha_cancelacion":
          if (filtros.fecha_cancelacion.length > 0) {
            result = result?.filter((i) =>
              filtros.fecha_cancelacion.includes(i.fechacancelacion),
            );
          }
          break;

        default:
          break;
      }
    });

    setDatosFiltrados(result);
  }, [data, filtros, prioridadFiltros]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const getBaseData = (filtro) => {
      const index = prioridadFiltros.indexOf(filtro);

      // Si el filtro NO ha sido usado aún → usar data filtrada actual
      if (index === -1) {
        return aplicarFiltros(data, filtros, null, prioridadFiltros);
      }

      // Si es el primero → data completa
      if (index === 0) {
        return data;
      }

      // Solo aplicar filtros con MAYOR prioridad
      const filtrosPrevios = prioridadFiltros.slice(0, index);

      return aplicarFiltros(data, filtros, null, filtrosPrevios);
    };

    // ORIGEN
    const origenOptions = [
      ...new Set(getBaseData("origen").map((i) => i.origen)),
    ].map((v) => ({ value: v, label: v }));

    const fechaOptions = [
      ...new Set(getBaseData("fecha").map((i) => i.fecha)),
    ].map((v) => ({ value: v, label: v }));

    const serieFiscalOptions = [
      ...new Set(getBaseData("serie_fiscal").map((i) => i.serie_fiscal)),
    ].map((v) => ({ value: v, label: v }));

    // CUENTA
    const cuentaOptions = [
      ...new Set(getBaseData("cuenta").map((i) => i.cuenta)),
    ].map((v) => ({ value: v, label: v }));

    // COMPROBANTE
    const comprobanteOptions = [
      ...new Set(getBaseData("comprobante").map((i) => i.tipoComprobante)),
    ].map((v) => ({ value: v, label: v }));

    // CONDICION
    const condicionOptions = [
      ...new Set(getBaseData("condicion").map((i) => i.condicionPago)),
    ].map((v) => ({ value: v, label: v }));

    const canceladoOptions = [
      ...new Set(getBaseData("cancelado").map((i) => i.cancelado)),
    ].map((v) => ({
      value: String(v),
      label: v == 0 ? "No" : "Si",
    }));

    const fechaCancelacionOptions = [
      ...new Set(
        getBaseData("fecha_cancelacion").map((i) => i.fechacancelacion),
      ),
    ].map((v) => ({ value: v, label: v }));

    setOptions({
      origen: origenOptions,
      fecha: fechaOptions,
      serie_fiscal: serieFiscalOptions,
      cuenta: cuentaOptions,
      comprobante: comprobanteOptions,
      condicion: condicionOptions,
      cancelado: canceladoOptions,
      fecha_cancelacion: fechaCancelacionOptions,
    });
  }, [data, filtros, prioridadFiltros]);

  const origenTexto =
    filtros.origen.length > 0
      ? filtros.origen.join(", ")
      : options.origen.map((o) => o.value).join(", ");

  useEffect(() => {
    if (!onOrigenChange) return;

    const datos = datosFiltrados.length > 0 ? datosFiltrados : data;

    const importe = datos.reduce(
      (acc, r) => acc + (Number(r.importe) || 0),

      0,
    );

    const registros = datos.length;

    onOrigenChange({
      origen: origenTexto,

      importe,

      registros,
    });
  }, [origenTexto, datosFiltrados, data]);

  return (
    <table>
      <thead>
        <tr>
          <th>
            {/* <div> */}
            <FiltroMultiple
              label="Origen"
              field="origen"
              options={options.origen}
              filtros={filtros}
              setFiltros={setFiltros}
              filtrosTemp={filtrosTemp}
              setFiltrosTemp={setFiltrosTemp}
              mostrarFiltro={mostrarFiltro}
              setMostrarFiltro={setMostrarFiltro}
              actualizarPrioridad={actualizarPrioridad}
              setPrioridadFiltros={setPrioridadFiltros}
            />
            {/* </div> */}
          </th>
          <th>
            <div className="borde-izq">Documento</div>
          </th>
          <th>
            <div className="borde-izq">Cust. Ord. No.</div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Fecha"
                field="fecha"
                options={options.fecha}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">Ro. Number</div>
          </th>
          <th>
            <div className="borde-izq">Special Inst.</div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Serie Fiscal"
                field="serie_fiscal"
                options={options.serie_fiscal}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">Folio Fiscal</div>
          </th>
          <th>
            <div className="borde-izq">Batch</div>
          </th>
          <th>
            <div className="borde-izq">Cuenta</div>
          </th>
          <th>
            <div className="borde-izq">UUID</div>
          </th>
          <th>
            <div className="borde-izq">RFC</div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Tipo de Comprobante"
                field="comprobante"
                options={options.comprobante}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Condicion de Pago"
                field="condicion"
                options={options.condicion}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Cancelado"
                field="cancelado"
                options={options.cancelado}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Fecha de Cancelacion"
                field="fecha_cancelacion"
                options={options.fecha_cancelacion}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">Importe</div>
          </th>
        </tr>
      </thead>
      <tbody>
        {(datosFiltrados.length > 0 ? datosFiltrados : data).map((d) => (
          <tr>
            <td className="ta-center">{d.origen}</td>
            <td className="ta-center">{d.documento}</td>
            <td className="ta-center">{d.cust_ord_no}</td>
            <td className="ta-center">
              {new Date(d.fecha).toLocaleDateString("es-MX", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </td>
            <td className="ta-center">{d.ro_number}</td>
            <td className="ta-left">{d.special_inst}</td>
            <td className="ta-center">{d.serie_fiscal}</td>
            <td className="ta-center">{d.folio_fiscal}</td>
            <td className="ta-center">{d.batch}</td>
            <td className="ta-center">{d.cuenta}</td>
            <td className="ta-center">{d.uuid}</td>
            <td className="ta-center">{d.rfc}</td>
            <td className="ta-center">
              {capitalizePalabras(d.tipoComprobante)}
            </td>
            <td className="ta-center">{capitalizePalabras(d.condicionPago)}</td>
            <td className="ta-center">{d.cancelado == 0 ? "No" : "Si"}</td>
            <td className="ta-center">
              {d.fechacancelacion
                ? new Date(d.fechacancelacion).toLocaleDateString("es-MX", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                : "-"}
            </td>
            <td className="ta-right">{FormatMoney(d.importe)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
